import self from '@/common/utils/global-config';
import Swagger from '@/common/utils/swagger';
import * as Constants from '@/common/utils/constants';
import * as Messages from '@/common/utils/messages';
import * as Tools from '@/common/utils/tools';
import * as ServiceConfig from '@/common/utils/service-config.js';

export default {
  data() {
    return {
      perpetual: Constants,
      promptInfo: [],
      periodInfo: {},
      separateCaption: {},
      //
      isHosArea: self.$sn.getConfig('isHosArea'),
      isOpenCardManage: self.$sn.getConfig('isOpenCardManage'),
      appointmentContent: self.$sn.getConfig('appointmentContent'),
      restrictAppointmentRecordPayTime: self.$sn.getConfig('restrictAppointmentRecordPayTime'),
      restrictTodayRegisterRecordPayTime: self.$sn.getConfig('restrictTodayRegisterRecordPayTime'),
      isShowTimeSerialOnAppointmentRecord: self.$sn.getConfig('isShowTimeSerialOnAppointmentRecord'),
      isShowScheduleCostAppointment: self.$sn.getConfig('isShowScheduleCostAppointment'),
      restrictAppointmentRecordDeleteDate: self.$sn.getConfig('restrictAppointmentRecordDeleteDate'),
      //
      exhibitionPayPattern: false,
      payPatternParams: {}
    };
  },
  methods: {
    appointment_mixin_getPromptInfo(record, type) {
      this.promptInfo = [];
      const url = {
        'candidate': '/hos/ui/caption/appointment/candidate/prompt.js',
        'ordinary': '/hos/ui/caption/appointment/prompt.js'
      };
      if (this.$sn.validate.empty(type)) type = 'ordinary';
      this.$sn.utils.ordinaryRequest({
        domain: 'static',
        url: url[type] + '?time=' + this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyyMMddHHmmss')
      }).then(result => {
        if (result && this.$sn.validate.object(result)) {
          if (result[this.$sn.utils.getHospitalId()] && result[this.$sn.utils.getHospitalId()].length > 0) {
            this.promptInfo = result[this.$sn.utils.getHospitalId()];
          }
          else if (result.ordinary && result.ordinary.length > 0) {
            this.promptInfo = result.ordinary;
          }
        }
        if (type === 'ordinary') {
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SZY) {
            if (this.$route.path !== '/appointment/confirm') {
              const prompt = {
                '0': '西区预约患者，请于就诊前半小时到科室分诊区域刷卡报到取条。',
                '1': '东区预约患者，请就诊前半小时持就诊卡在门诊扁鹊楼各楼层自助机领取预约票。'
              };
              this.promptInfo.push({
                info: prompt[record.hosArea] + '<br>注：第一次预约就诊需持身份证与就诊卡在自助机或建卡充值窗口进行实名认证。',
                style: '',
                sort: '1.9',
                type: '1'
              });
              this.promptInfo.push({
                info: '如需查看预约详情、或取消预约，请到【个人中心】-【预约记录】菜单中查看。',
                style: '',
                sort: '2.8',
                type: '1'
              });
            }
          }
          else if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_YTS) {
            if (record.isToday === 1) {
              this.promptInfo.push({
                info: '儿童线上挂号必须实名建档，建档后第一次就诊前需先到窗口补办健康卡。',
                style: '',
                sort: '5',
                type: '1'
              });
            }
            else {
              this.promptInfo.push({
                info: '儿童线上预约必须实名建档，建档后第一次就诊前需先到窗口补办健康卡，再到自助机上取号报到。',
                style: '',
                sort: '5',
                type: '1'
              });
            }
          }
          else if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_QDQL) {
            this.promptInfo = [];
            if (!record.outCardSerial) {
              this.promptInfo.push({
                info: '请携带身份证在预约时间之前到医院取号。',
                style: '',
                sort: '1',
                type: '2'
              });
              this.promptInfo.push({
                info: '如需取消预约，请在就诊日前一日操作。',
                style: '',
                sort: '2',
                type: '1'
              });
            }
          }
          else if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_QDSL) {
            if (['X', 'D', 'R'].includes(record.hosArea)) {
              this.promptInfo = [{
                info: '就诊:请在预约时间前15分钟内到院，直接在护士站签到，无须现场取号;<br>候诊:系统将按照预约时间及序号安排候诊，前面如遇疑难病患者，就诊时间可能会有延迟，请您耐心等待。<br>停车:凭当日就诊凭证免费停车2小时，超过2小时，按停车场收费标准收费。医院停车位紧张，为避免迟到过号，请您尽量选择绿色出行。',
                style: '',
                sort: '4',
                type: '2'
              }, {
                info: '查询“挂号预约记录”，请进入：诊疗服务-我的-挂号预约记录，即可查阅。',
                style: '',
                sort: '5',
                type: '2'
              }, {
                info: '退费：取消预约，费用将在1-7个工作日内原路退回到您的账户。',
                style: '',
                sort: '6',
                type: '2'
              }];
            }
            else {
              if (record.state === 1 && record.hosState === 4) {
                this.promptInfo.push({
                  info: '该医生当日排班临时取消，您的预约失效。带来不便，敬请谅解！',
                  style: '',
                  sort: '0.9',
                  type: '2'
                });
              }
            }
          }
          else if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_ETYY) {
            this.promptInfo = [];
            if (this.$route.path !== '/appointment/confirm') {
              if (this.$sn.utils.isOpenFunction(this.perpetual.FUNCTION_ID_YYQD) && record.state === 1 && record.hosState === 3) {
                this.promptInfo.push({
                  info: '您已签到，凭此签到信息直接等候叫号就诊，无需现场自助取号！',
                  style: '',
                  sort: '1',
                  type: '2'
                });
              }
            }
          }
          else if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_WHSLDSYY) {
            if (record.isToday === 0) {
              this.promptInfo.push({
                info: '请携带好就诊人的身份证（健康码，医保卡）到人工窗口、自助机取号就诊。',
                style: '',
                sort: '0.8',
                type: '2'
              });
              this.promptInfo.push({
                info: '如需取消预约，请在就诊前取消预约操作。',
                style: '',
                sort: '0.9',
                type: '2'
              });
            }
            else if (record.isToday === 1) {
              this.promptInfo.push({
                info: '请携带好就诊人的身份证（健康码，医保卡）到就诊科室就诊。',
                style: '',
                sort: '0.8',
                type: '2'
              });
              this.promptInfo.push({
                info: '如需取消挂号，请在就诊前取消挂号操作。',
                style: '',
                sort: '0.9',
                type: '2'
              });
            }
          }
          else if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL) {
            if (this.$route.path !== '/appointment/confirm') {
              if (record.isToday === 0) {
                this.promptInfo[0] = {
                  info: '如需取消预约，请在就诊前一日取消。',
                  style: '',
                  sort: '1',
                  type: '1'
                };
              }
              else {
                if (this.promptInfo.length > 0) {
                  this.promptInfo = this.$sn.format.clone(this.promptInfo).slice(1);
                }
              }
            }
          }
          if (this.promptInfo.length === 0 && !this.$sn.getConfig('isOpenCancelAppointment')) {
            this.promptInfo.push({
              info: '请携带身份证在预约时间之前到医院取号。',
              style: '',
              sort: '1',
              type: '1'
            });
            this.promptInfo.push({
              info: '如需取消预约，请到医院现场取消。',
              style: '',
              sort: '2',
              type: '1'
            });
          }
        }
        this.promptInfo = this.$sn.format.digitalSort(this.promptInfo);
      });
    },
    appointment_mixin_getSeparateCaption() {
      this.separateCaption = {};
      this.$sn.utils.ordinaryRequest({
        domain: 'static',
        url: '/hos/ui/caption/appointment/record-separate.js?time=' + this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyyMMddHHmmss')
      }).then(result => {
        if (result && this.$sn.validate.object(result) && !this.$sn.validate.empty(result[this.$sn.utils.getHospitalId()])) {
          this.separateCaption = result[this.$sn.utils.getHospitalId()];
        }
      });
    },
    appointment_mixin_getEntranceInfo() {
      return new Promise(resolve => {
        this.$sn.utils.ordinaryRequest({
          domain: 'static',
          url: '/hos/ui/caption/other/entrance.js?time=' + this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyyMMddHHmmss')
        }).then(result => {
          if (result && this.$sn.validate.object(result) && !this.$sn.validate.empty(result[this.$sn.utils.getHospitalId()])) {
            resolve(result[this.$sn.utils.getHospitalId()]);
          }
          else resolve([]);
        });
      });
    },
    appointment_mixin_period() {
      return new Promise(resolve => {
        if (!this.$sn.validate.empty(this.periodInfo)) {
          resolve(this.periodInfo);
          return false;
        }
        Tools.dict([this.perpetual.DICTIONARY_CODE_SCHEDULE_NOON]).then(result => {
          if (!this.$sn.validate.empty(result)) {
            result.forEach(el => {
              this.$set(this.periodInfo, el.itemCode, el);
            });
          }
          resolve(this.periodInfo);
        });
      });
    },
    appointment_mixin_formatAreaCaption(item, type = '0') {
      const area = item.areaId || item.hosArea || this.$sn.utils.getHospitalAreaId();
      const depart = item.deptId;
      let caption = '';
      if (type === '0') {
        if (this.$sn.format.getQuality(this.separateCaption, 'AREA.' + depart)) {
          caption = this.$sn.format.getQuality(this.separateCaption, 'AREA.' + depart);
        }
        else caption = this.$sn.utils.getHospitalAreaInformation(area).areaName;
      }
      else {
        caption = this.$sn.utils.getHospitalAreaInformation(area)[type];
      }
      return caption;
    },
    appointment_mixin_compare(doctor, config) {
      if (this.$sn.validate.empty(config) || !this.$sn.validate.array(config)) return doctor;
      const compare = doctor;
      config.forEach(el => {
        compare.sort(this['appointment_mixin_' + el]);
      });
      return compare;
    },
    // 依据医生信息中 sort 字段进行排序
    appointment_mixin_isSortSchedulePriorityBySort(val1, val2) {
      return parseFloat(val1.doctorOrder) - parseFloat(val2.doctorOrder);
    },
    // 依据医生信息中职称字段进行排序
    appointment_mixin_isSortSchedulePriorityByTitle(val1, val2) {
      const title = [
        {
          title: '知名专家',
          value: 0
        },
        {
          title: '主任医师',
          value: 1
        },
        {
          title: '副主任医师',
          value: 2
        },
        {
          title: '主治医师',
          value: 3
        },
        {
          title: '住院医师',
          value: 4
        }
      ];
      let value1 = 9999;
      let value2 = 9999;
      if (!this.$sn.validate.empty(title.find(result => val1.doctorTitle && val1.doctorTitle.indexOf(result.title) > -1))) {
        value1 = title.find(result => val1.doctorTitle.indexOf(result.title) > -1).value;
      }
      if (!this.$sn.validate.empty(title.find(result => val2.doctorTitle && val2.doctorTitle.indexOf(result.title) > -1))) {
        value2 = title.find(result => val2.doctorTitle.indexOf(result.title) > -1).value;
      }
      return value1 - value2;
    },
    // 依据医生信息中医生名称字段首字母进行排序
    appointment_mixin_isSortSchedulePriorityByContent(val1, val2) {
      return val1.doctorName.localeCompare(val2.doctorName, 'zh');
    },
    // 依据医生信息中首条排班日期进行排序
    appointment_mixin_isSortScheduleByDate(val1, val2) {
      const value1 = val1.schedules && val1.schedules.length > 0 ? val1.schedules[0].scheduleDate : '9999-99-99';
      const value2 = val2.schedules && val2.schedules.length > 0 ? val2.schedules[0].scheduleDate : '9999-99-99';
      if (value1 < value2) return -1;
      if (value1 > value2) return 1;
      return 0;
    },
    // 依据医生信息中首条排班午别进行排序
    appointment_mixin_isSortScheduleByTime(val1, val2) {
      if (this.periodInfo[val1.schedules[0].scheduleNoonCode].sort < this.periodInfo[val2.schedules[0].scheduleNoonCode].sort) return -1;
      if (this.periodInfo[val1.schedules[0].scheduleNoonCode].sort > this.periodInfo[val2.schedules[0].scheduleNoonCode].sort) return 1;
      return 0;
    },
    // 依据医生信息中首条排班诊疗费进行排序
    appointment_mixin_isSortScheduleByGrade(val1, val2) {
      const compare = {
        '600': 4,
        '300': 4,
        '200': 4,
        '100': 4,
        '35': 3,
        '25': 2
      };
      return (compare[val1.schedules[0].regFee] || 1) - (compare[val2.schedules[0].regFee] || 1);
    },
    /*
    2022年5月24日13:51:47 LXC
    是否展示取消预约按钮
     */
    appointment_mixin_verifyCancelAppointmentInteraction(item) {
      let verify = false;
      if (item.state === 1 && (item.hosState === 0 || (this.$sn.getConfig('isOpenSignInCancelAppointment') && item.hosState === 3))) {
        if (this.$sn.getConfig('isOpenCancelAppointment')) {
          if ([this.perpetual.HOSPITAL_ID_WFFY, this.perpetual.HOSPITAL_ID_JNYZ].includes(this.$sn.utils.getHospitalId())) {
            verify = true;
          }
          if ((this.$sn.getConfig('isOpenPaidCancelAppointment') && item.isDopay === 1) || item.isDopay === 0) {
            let permit = '';
            if (item.isToday === 1 && !this.$sn.validate.empty(this.$sn.getConfig('permitEndDateCancelTodayRegister'))) {
              permit = this.$sn.getConfig('permitEndDateCancelTodayRegister');
            }
            else permit = this.$sn.getConfig('permitEndDateCancelAppointment');
            if (permit === 'none') permit = '0000-00-00';
            else permit = this.$sn.format.date(new Date(), 'yyyy-MM-dd', permit, 'day');
            if (item.schDate > permit) {
              verify = true;
            }
            else if (item.schDate === permit) {
              if ((this.$sn.getConfig('isOpenCancelAppointmentByTime') && this.appointment_mixin_compareAppointmentRecordTime(item)) ||
              (['', '5'].includes(item.noonCode) && this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') < this.$sn.getConfig('permitEndDawnTimeCancelAppointment')) ||
              (['', '0', '1'].includes(item.noonCode) && this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') < this.$sn.getConfig('permitEndMorningTimeCancelAppointment')) ||
              (['', '12'].includes(item.noonCode) && this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') < this.$sn.getConfig('permitEndNoonTimeCancelAppointment')) ||
              (['', '2'].includes(item.noonCode) && this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') < this.$sn.getConfig('permitEndAfternoonTimeCancelAppointment')) ||
              (['', '4'].includes(item.noonCode) && this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') < this.$sn.getConfig('permitEndEveningTimeCancelAppointment'))) {
                verify = true;
              }
            }
          }
        }
      }
      return verify;
    },
    /*
    2022年5月24日12:06:01 LXC
    是否展示待支付倒计时
     */
    appointment_mixin_verifyPayRestrictTimeCaption(record) {
      let verify = false;
      if ((record.isToday === 0 && this.restrictAppointmentRecordPayTime > 0 && parseInt(new Date().getTime().toString().substring(0, 10)) - new Date(record.opTime).getTime() / 1000 < this.restrictAppointmentRecordPayTime) ||
      (record.isToday === 1 && this.restrictTodayRegisterRecordPayTime > 0 && parseInt(new Date().getTime().toString().substring(0, 10)) - new Date(record.opTime).getTime() / 1000 < this.restrictTodayRegisterRecordPayTime)) {
        if ((record.isToday === 0 && this.restrictAppointmentRecordPayTime !== 86400) ||
        (record.isToday === 1 && this.restrictTodayRegisterRecordPayTime !== 86400)) {
          if (record.time) {
            verify = true;
          }
        }
      }
      return verify;
    },
    appointment_mixin_formatTime(time, el) {
      const m = Math.floor(time / 60);
      if (m.toString().length >= 2) {
        el.time = m.toString();
      }
      else if (m.toString().length === 1) {
        el.time = '0' + m.toString();
      }
      const s = time - m * 60;
      if (s.toString().length >= 2) {
        el.time += ':' + s.toString();
      }
      else if (s.toString().length === 1) {
        el.time += ':0' + s.toString();
      }
    },
    appointment_mixin_formatRecordDoctorTitle(item) {
      if (this.$sn.getConfig('isExchangeDoctorTitleByScheduleCost')) {
        if (item.regFee) {
          let value = '';
          if (parseFloat(item.regFee) === 100 || parseFloat(item.regFee) === 200 || parseFloat(item.regFee) === 300) {
            value = '知名专家';
          }
          else if (parseFloat(item.regFee) === 28 || parseFloat(item.regFee) === 31) {
            value = '主任医师';
          }
          else if (parseFloat(item.regFee) === 21) {
            value = '副主任医师';
          }
          else if (parseFloat(item.regFee) < 21) {
            value = '普通号';
          }
          return value;
        }
        else {
          return item.doctorTitle;
        }
      }
      else {
        return item.doctorTitle;
      }
    },
    /*
    2022年5月24日12:06:38 LXC
    是否展示立即支付按钮
     */
    appointment_mixin_verifyPayPromptInteraction(record) {
      let verify = false;
      if (record.state === 1 && record.hosState === 0) {
        if (record.isDopay === 0 && record.regFee && parseFloat(record.regFee) > 0) {
          if (record.patientCardId) {
            if (this.appointment_mixin_compareAppointmentRecordPayTime(record)) {
              if ((this.$sn.getConfig('isRestrictAppointmentRecordScheduleTime') && this.appointment_mixin_compareAppointmentRecordScheduleTime(record)) ||
              (this.$sn.getConfig('isOpenOptPayConditionTodayRegister') && record.isToday === 1)) {
                verify = true;
              }
              else if ((record.isToday === 1 && this.$sn.getConfig('isOpenPayPromptTodayRegisterRecord')) || (record.isToday !== 1 && this.$sn.getConfig('isOpenPayPromptAppointmentRecord'))) {
                verify = true;
              }
              else if ((record.isToday === 0 && this.restrictAppointmentRecordPayTime > 0) || (record.isToday === 1 && this.restrictTodayRegisterRecordPayTime > 0)) {
                if (this.$sn.utils.isOpenFunction(this.perpetual.FUNCTION_ID_HBGH) && record.candidateFlag === '1') {
                  verify = true;
                }
                else {
                  let standard = this.restrictAppointmentRecordPayTime;
                  if (record.isToday === 1) standard = this.restrictTodayRegisterRecordPayTime;
                  if (parseInt(new Date().getTime().toString().substring(0, 10)) - new Date(record.opTime).getTime() / 1000 < standard) {
                    verify = true;
                  }
                }
              }
            }
          }
        }
      }
      return verify;
    },
    appointment_mixin_compareAppointmentRecordTime(record) {
      const standard = record.isToday === 1 ? this.$sn.getConfig('isOpenCancelTodayRegisterByTimeInterval') : this.$sn.getConfig('isOpenCancelAppointmentByTimeInterval');
      if (standard < 0) {
        return this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') < '240000';
      }
      else {
        let value = record.schTime.replaceAll(':', '');
        if (value.length === 4) {
          value = value + '00';
        }
        return this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyyMMddHHmmss', standard, 'second') <= (record.schDate.replaceAll('-', '') + value);
      }
    },
    appointment_mixin_compareAppointmentRecordPayTime(record) {
      if (record.schDate && record.schTime) {
        if (record.schDate >= this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', this.$sn.getConfig('restrictAppointmentRecordPayDate'), 'day')) {
          if (record.schDate === this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd')) {
            let value = '';
            if (record.schTime.split('-').length === 2) {
              value = record.schTime.split('-')[1].substring(0, 2) + record.schTime.split('-')[1].substring(3, 5) + '00';
            }
            else {
              value = record.schTime.substring(0, 2) + record.schTime.substring(3, 5) + '00';
            }
            if (this.$sn.getConfig('isOpenPayZeroTodayRegisterRecord') && record.isToday === 1) {
              value = '240000';
            }
            return this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') <= value;
          }
          else {
            return true;
          }
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    },
    appointment_mixin_compareAppointmentRecordScheduleTime(record) {
      const identify = this.$sn.getConfig('restrictAppointmentRecordScheduleTimeIdentify').split(',');
      if (identify && identify.length > 0) {
        if (identify.length > 1) {
          if (this.$sn.format.date(new Date(record.schDate), 'yyyy-MM-dd', parseInt(identify[0]), 'day') > this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd')) {
            return false;
          }
          else if (this.$sn.format.date(new Date(record.schDate), 'yyyy-MM-dd', parseInt(identify[0]), 'day') === this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd')) {
            return this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') >= identify[1];
          }
          else if (record.schDate === this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd')) {
            let value = '';
            if (record.schTime.split('-').length === 2) {
              value = record.schTime.split('-')[1];
            }
            else {
              value = record.schTime;
            }
            const context = this.$sn.format.date(new Date(record.schDate + ' ' + value), 'HHmmss', parseInt(identify[2]), 'second');
            return this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') <= context;
          }
        }
        else {
          return this.$sn.format.date(new Date(record.schDate), 'yyyy-MM-dd', parseInt(identify[0]), 'day') <= this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd');
        }
      }
      else {
        return false;
      }
    },
    async appointment_mixin_payRecordHandle(digit, pattern, reg) {
      const {
        record,
        patient
      } = digit;
      const getBalance = () => {
        return new Promise(resolve => {
          const params = {
            url: Swagger.getCardBalance,
            method: 'POST',
            header: true,
            data: JSON.stringify({
              bindType: this.$sn.utils.getPlatformType(),
              cardNo: record.patientCardId,
              clinicType: this.perpetual.OUT_CARD_CLINIC_TYPE,
              hosArea: '',
              hosId: this.$sn.utils.getHospitalId(),
              idCardNo: '',
              openId: this.$sn.utils.getOpenId(),
              patName: '',
              patientId: record.patientId,
              reservedDate: '',
              state: ''
            })
          };
          this.$sn.utils.ordinaryRequest(params).then(result => {
            const fructify = {
              code: 0,
              msg: '',
              data: {}
            };
            if (result) {
              if (result.code === 0 && result.data && result.data.cardBalance) {
                fructify.data = result.data;
              }
              else {
                fructify.code = 2;
                fructify.msg = Messages.RECHARGE010;
              }
            }
            else {
              fructify.code = 1;
              fructify.msg = Messages.C001;
            }
            resolve(fructify);
          });
        });
      };
      /* eslint-disable */
      const dict = await Tools.dict([this.perpetual.DICTIONARY_CODE_PAY_MODE]);
      let gather = record.isToday === 1 ? this.$sn.getConfig('payPatternTodayRegister').split(',') : this.$sn.getConfig('payPatternAppointment').split(',');
      let balance = {}; // 就诊卡余额
      let fee = {}; // 核准挂号费
      /* eslint-enable */
      if (!this.$sn.validate.empty(gather.find(result => result === this.perpetual.DICT_PAY_MODE_CARD))) {
        this.$sn.assembly.loading(true);
        balance = await getBalance();
        fee = await this.appointment_mixin_cost(record);
        this.$sn.assembly.loading(false);
        if (!this.$u.getProperty(fee, 'data.regFee')) {
          this.$sn.assembly.modal({
            caption: fee.msg,
            isCancel: false
          });
          return false;
        }
        else record.regFee = fee.data.regFee;
      }
      if (gather.length > 0) {
        // 如当前仅有一个支付方式，则直接使用
        if (gather.length === 1) pattern = gather[0];
        // 如当前仍为选择支付方式，则指引用户选择支付方式
        if (!pattern) {
          // TODO
          return false;
        }
        if (!reg) {
          this.payPatternParams = {
            digit: digit,
            func: record.isToday === 1 ? this.perpetual.FUNCTION_ID_JRGH : this.perpetual.FUNCTION_ID_GHYY,
            reg: this.$sn.getConfig('pcPayPattern')
          };
          this.exhibitionPayPattern = true;
          return false;
        }
        // 就诊卡支付前置处理
        if (pattern === this.perpetual.DICT_PAY_MODE_CARD) {
          this.$sn.assembly.loading(true);
          this.appointment_mixin_card(record, patient, reg);
        }
        // 自费支付前置处理
        else if (pattern === this.perpetual.DICT_PAY_MODE_SELF) {
          const startMinDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd') + ' ' + this.$sn.getConfig('rechargeEndTime') + ':00';
          const startMaxDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd', 1, 'day') + ' 00:00:00';
          const endMinDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd') + ' 00:00:00';
          const endMaxDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd') + ' ' + this.$sn.getConfig('rechargeStartTime') + ':00';
          const current = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd HH:mm:ss');
          if (this.$sn.validate.range(current, [startMinDate, startMaxDate]) || this.$sn.validate.range(current, [endMinDate, endMaxDate])) {
            this.$sn.assembly.modal({
              caption: this.$sn.format.caption(Messages.APPOINT029, [this.appointmentContent, this.$sn.getConfig('rechargeStartTime'), this.$sn.getConfig('rechargeEndTime')]),
              isCancel: false
            });
            return false;
          }
          this.$sn.assembly.loading(true);
          this.$sn.utils.setHospitalLocalStorage('Appointment_CompleteInfo', record);
          this.appointment_mixin_platform(record, patient, reg);
        }
      }
      else {
        this.$sn.assembly.modal({
          caption: this.$sn.format.caption(Messages.C018, ['支付方式']),
          isCancel: false
        });
      }
    },
    appointment_mixin_cost(record) {
      return new Promise(resolve => {
        const result = {
          code: 0,
          data: {},
          msg: ''
        };
        const code = {
          [this.perpetual.HOSPITAL_ID_SDSL]: '99635522-34ff-45f4-9a49-3330b6365620'
        };
        if (code[this.$sn.utils.getHospitalId()]) {
          this.$sn.utils.ordinaryRequest({
            url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), code[this.$sn.utils.getHospitalId()]]),
            method: 'POST',
            header: true,
            data: this.$sn.utils.variableEncryption(this.$sn.format.xml({
              PatId: record.patientId,
              PlatformId: this.$sn.utils.getPlatformType(),
              PlatformUserId: this.$sn.utils.getOpenId(),
              ScheduleItemCode: record.schId
            }))
          }, ServiceConfig.ordinaryTransmitLoginComplete).then(res => {
            if (res) {
              if (res.code === 0) {
                if (res.data) {
                  if (res.data.ResultCode === '0') {
                    if (res.data.Data && res.data.Data.regFee) {
                      result.data = res.data.Data;
                    }
                    else {
                      result.code = 2;
                      result.msg = this.$sn.format.caption(this.$sn.utils.getSessionStorage('HospitalMessages').C.C018, ['挂号费']);
                    }
                  }
                  else {
                    result.code = res.data.ResultCode;
                    result.msg = res.data.ResultMsg;
                  }
                }
                else {
                  result.code = 2;
                  result.msg = this.$sn.format.caption(this.$sn.utils.getSessionStorage('HospitalMessages').C.C018, ['挂号费']);
                }
              }
              else {
                result.code = res.code;
                result.msg = res.msg;
              }
            }
            else {
              result.code = 1;
              result.msg = this.$sn.utils.getSessionStorage('HospitalMessages').C.C001;
            }
            resolve(result);
          });
        }
        else {
          this.$set(result.data, 'regFee', record.regFee);
          resolve(result);
        }
      });
    },
    appointment_mixin_card(record, patient, reg) {
      const params = {
        url: this.$sn.format.caption(Swagger.robotizationDeductionAppointment,
          [this.$sn.utils.getPlatformType(), this.$sn.utils.getHospitalId(), this.$sn.utils.getOpenId(), record.appointId]),
        query: {
          msgType: this.$sn.getConfig('isSendInfoTypeRobotizationDeduction') ? 1 : 3
        },
        method: 'PUT',
        header: true
      };
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result) {
          if (result.code === 0) {
            if (record.state === 3) {
              record.state = 1;
            }
            record.isDopay = 1;
            let caption = '支付';
            if (this.$route.path === '/appointment/confirm') {
              this.appointmentContent = '挂号';
              caption = this.appointmentContent;
            }
            this.$sn.utils.setHospitalLocalStorage('Appointment_CompleteInfo', record);
            this.$sn.assembly.toast({
              caption: this.$sn.format.caption(Messages.C016, [caption]),
              mode: 'success',
              success: () => {
                if (this.$route.path === '/appointment/confirm') {
                  this.appointment_mixin_navigateUrl('/appointment/complete', '', {}, 'replace');
                }
              }
            });
          }
          else {
            if (result.msg.indexOf(Messages.RECHARGE001) !== -1) {
              this.$sn.utils.setHospitalLocalStorage('Appointment_CompleteInfo', record);
              this.homepage_mixin_rechargeTransit({
                type: 'appointment-record',
                patient: patient,
                cost: record.regFee,
                reg: reg,
                item: record,
                params: {
                  func: record.isToday === 1 ? this.perpetual.FUNCTION_ID_JRGH : this.perpetual.FUNCTION_ID_GHYY,
                  title: '请您扫码进行支付',
                  sub: '',
                  label: '挂号',
                  interaction: {
                    text: '前往挂号预约记录',
                    disabled: false,
                    func: () => {
                      this.appointment_mixin_navigateUrl('/appointment/record', '', {}, 'replace');
                    }
                  },
                  swagger: params
                }
              });
            }
            else {
              if (this.$route.path === '/appointment/confirm' && record.state === 1) {
                let caption = result.msg;
                if (this.$sn.utils.getHospitalId() !== this.perpetual.HOSPITAL_ID_SDSZL) {
                  caption += '，' + this.$sn.format.caption(Messages.APPOINT039, [this.appointmentContent, this.$sn.getConfig('costContentTitle')]);
                }
                this.$sn.assembly.modal({
                  caption: caption,
                  isCancel: false,
                  captionConfirm: '立即支付',
                  success: (modal) => {
                    if (modal.confirm) {
                      this.appointment_mixin_navigateUrl('/appointment/record-info', '', {
                        id: record.appointId
                      }, 'replace');
                    }
                  }
                });
              }
              else {
                this.$sn.assembly.modal({
                  caption: result.msg,
                  isCancel: false
                });
              }
            }
          }
        }
        else {
          if (this.$route.path === '/appointment/confirm' && record.state === 1) {
            this.$sn.assembly.modal({
              caption: this.$sn.format.caption(Messages.APPOINT039, [this.appointmentContent, this.$sn.getConfig('costContentTitle')]),
              isCancel: false,
              captionConfirm: '立即支付',
              success: (modal) => {
                if (modal.confirm) {
                  this.appointment_mixin_navigateUrl('/appointment/record-info', '', {
                    id: record.appointId
                  }, 'replace');
                }
              }
            });
          }
          else {
            let caption = this.$sn.format.caption(Messages.C017, [this.appointmentContent]);
            if (this.$route.path === '/appointment/confirm' && record.state !== 3) {
              caption = Messages.C001;
            }
            this.$sn.assembly.modal({
              caption: caption,
              isCancel: false
            });
          }
        }
      });
    },
    async appointment_mixin_platform(record, patient, reg) {
      let primary = reg;
      const ExtendInfo = {};
      let ip = '';
      if (this.$sn.utils.getSubRegType(reg)) {
        this.$set(ExtendInfo, 'subPayType', this.$sn.utils.getSubRegType(reg));
        if (this.$sn.utils.isYuanQi()) {
          this.$set(ExtendInfo, 'patId', patient.outCardId);
          this.$set(ExtendInfo, 'patName', patient.patientName);
          if (this.$sn.utils.getRegType() === this.perpetual.REG_TYPE_YUANQI2) {
            ip = await Tools.getIp();
          }
        }
        this.$set(ExtendInfo, 'busType', record.isToday === 1 ? this.perpetual.PAY_BUSINESS_TYPE_TODAY_REGISTER : this.perpetual.PAY_BUSINESS_TYPE_APPOINTMENT);
        primary = this.$sn.utils.getRegType();
      }
      let PayAccountNo = this.$sn.getConfig('appointmentMerchantSerial');
      if (this.$sn.validate.object(PayAccountNo)) {
        if (this.$sn.validate.empty(PayAccountNo[record.hosArea])) {
          PayAccountNo = PayAccountNo.ordinary;
        }
        else {
          PayAccountNo = PayAccountNo[record.hosArea];
        }
      }
      this.$sn.utils.ordinaryRequest({
        url: Swagger.pcRegisterScanQR,
        method: 'POST',
        header: true,
        data: JSON.stringify({
          appointId: record.appointId,
          cardNo: record.patientCardId,
          extendInfo: this.$sn.validate.empty(ExtendInfo) ? '' : JSON.stringify(ExtendInfo),
          extendType: '',
          hosId: this.$sn.utils.getHospitalId(),
          ip: ip,
          limitPay: '',
          regType: primary,
          payAccountNo: PayAccountNo,
          projectType: this.$sn.utils.getProjectType(),
          type: this.$sn.utils.getPlatformType(),
          userId: this.$sn.utils.getOpenId()
        })
      }).then(result => {
        if (result) {
          if (result.code === 0) {
            if (result.data) {
              if (!this.$sn.validate.empty(result.data.outTradeNo) && !this.$sn.validate.empty(result.data.Data)) {
                this.$sn.utils.ordinaryRequest({
                  url: Swagger.storePaymentParameter,
                  method: 'POST',
                  data: JSON.stringify({
                    accountId: this.$sn.utils.getAccountId(),
                    cardNo: record.patientCardId,
                    cardType: this.perpetual.OUT_CARD_CLINIC_TYPE,
                    dataType: this.$sn.utils.getPlatformType(),
                    deptId: record.deptId,
                    deptName: record.deptName,
                    doctorId: record.doctorId,
                    doctorName: record.doctorName,
                    extendInfo: this.$sn.validate.empty(ExtendInfo) ? '' : JSON.stringify(ExtendInfo),
                    extendType: '',
                    hosId: this.$sn.utils.getHospitalId(),
                    noticeType: this.perpetual.NOTICE_TYPE_APPOINTMENT,
                    outTradeNo: result.data.outTradeNo,
                    patientId: record.patientId,
                    patientIdCard: patient.patientIdCardNo,
                    patientName: record.patientName,
                    patientPhone: record.patientPhone,
                    payAccountNo: PayAccountNo,
                    payType: this.$sn.utils.getRegType(),
                    platformId: this.$sn.utils.getPlatformType(),
                    platformUserId: this.$sn.utils.getOpenId(),
                    projectType: this.$sn.utils.getProjectType(),
                    totalFee: record.regFee
                  }),
                  reload: false
                }).then(res => {
                  this.$sn.assembly.loading(false);
                  if (res && res.code === 0 && res.data && res.data.ResultCode && (res.data.ResultCode === 0 || res.data.ResultCode === '0')) {
                    this.payResultParams = {
                      func: record.isToday === 1 ? this.perpetual.FUNCTION_ID_JRGH : this.perpetual.FUNCTION_ID_GHYY,
                      title: '请您扫码进行支付',
                      sub: '',
                      label: '挂号',
                      interaction: {
                        text: '前往挂号预约记录',
                        disabled: false,
                        func: () => {
                          this.appointment_mixin_navigateUrl('/appointment/record', '', {}, 'replace');
                        }
                      },
                      cost: record.regFee,
                      pay: {
                        [reg]: {
                          serial: result.data.outTradeNo,
                          qr: result.data.Data
                        }
                      }
                    };
                    this.exhibitionPayResult = true;
                  }
                  else {
                    if (this.$route.path === '/appointment/confirm' && record.state === 1) {
                      let caption = Messages.RECHARGE002 + '，';
                      caption += this.$sn.format.caption(Messages.APPOINT039, [this.appointmentContent, this.$sn.getConfig('costContentTitle')]);
                      this.$sn.assembly.modal({
                        caption: caption,
                        isCancel: false,
                        captionConfirm: '立即支付',
                        success: (modal) => {
                          if (modal.confirm) {
                            this.appointment_mixin_navigateUrl('/appointment/record-info', '', {
                              id: record.appointId
                            }, 'replace');
                          }
                        }
                      });
                    }
                    else {
                      this.$sn.assembly.modal({
                        caption: Messages.RECHARGE002,
                        isCancel: false
                      });
                    }
                  }
                });
              }
              else {
                this.$sn.assembly.loading(false);
                if (this.$route.path === '/appointment/confirm' && record.state === 1) {
                  let caption = Messages.RECHARGE003 + '，';
                  caption += this.$sn.format.caption(Messages.APPOINT039, [this.appointmentContent, this.$sn.getConfig('costContentTitle')]);
                  this.$sn.assembly.modal({
                    caption: caption,
                    isCancel: false,
                    captionConfirm: '立即支付',
                    success: (modal) => {
                      if (modal.confirm) {
                        this.appointment_mixin_navigateUrl('/appointment/record-info', '', {
                          id: record.appointId
                        }, 'replace');
                      }
                    }
                  });
                }
                else {
                  this.$sn.assembly.modal({
                    caption: Messages.RECHARGE003,
                    isCancel: false
                  });
                }
              }
            }
            else {
              this.$sn.assembly.loading(false);
              if (this.$route.path === '/appointment/confirm' && record.state === 1) {
                let caption = Messages.C002 + '，';
                caption += this.$sn.format.caption(Messages.APPOINT039, [this.appointmentContent, this.$sn.getConfig('costContentTitle')]);
                this.$sn.assembly.modal({
                  caption: caption,
                  isCancel: false,
                  captionConfirm: '立即支付',
                  success: (modal) => {
                    if (modal.confirm) {
                      this.appointment_mixin_navigateUrl('/appointment/record-info', '', {
                        id: record.appointId
                      }, 'replace');
                    }
                  }
                });
              }
              else {
                this.$sn.assembly.modal({
                  caption: Messages.C002,
                  isCancel: false
                });
              }
            }
          }
          else {
            this.$sn.assembly.loading(false);
            if (this.$route.path === '/appointment/confirm' && record.state === 1) {
              let caption = result.msg;
              if (this.$sn.utils.getHospitalId() !== this.perpetual.HOSPITAL_ID_SDSZL) {
                caption += '，' + this.$sn.format.caption(Messages.APPOINT039, [this.appointmentContent, this.$sn.getConfig('costContentTitle')]);
              }
              this.$sn.assembly.modal({
                caption: caption,
                isCancel: false,
                captionConfirm: '立即支付',
                success: (modal) => {
                  if (modal.confirm) {
                    this.appointment_mixin_navigateUrl('/appointment/record-info', '', {
                      id: record.appointId
                    }, 'replace');
                  }
                }
              });
            }
            else {
              this.$sn.assembly.modal({
                caption: result.msg,
                isCancel: false
              });
            }
          }
        }
        else {
          this.$sn.assembly.loading(false);
          if (this.$route.path === '/appointment/confirm' && record.state === 1) {
            this.$sn.assembly.modal({
              caption: this.$sn.format.caption(Messages.APPOINT039, [this.appointmentContent, this.$sn.getConfig('costContentTitle')]),
              isCancel: false,
              captionConfirm: '立即支付',
              success: (modal) => {
                if (modal.confirm) {
                  this.appointment_mixin_navigateUrl('/appointment/record-info', '', {
                    id: record.appointId
                  }, 'replace');
                }
              }
            });
          }
          else {
            let caption = this.$sn.format.caption(Messages.C017, [this.appointmentContent]);
            if (this.$route.path === '/appointment/confirm' && record.state !== 3) {
              caption = Messages.C001;
            }
            this.$sn.assembly.modal({
              caption: caption,
              isCancel: false
            });
          }
        }
      });
    },
    appointment_mixin_sendBackPayPattern(type, params) {
      if (type) {
        this.appointment_mixin_payRecordHandle(this.payPatternParams.digit, params.channel, params.reg);
      }
      this.exhibitionPayPattern = false;
      this.payPatternParams = {};
    },
    appointment_mixin_navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '/appointment/record-info') {
        this.$sn.utils.setHospitalSessionStorage('Appointment_RecordInfo', item);
        this.$router[type]({
          path: url,
          query: params || {}
        });
      }
      else if (url === 'delete') {
        if (this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd') >= this.$sn.format.date(new Date(item.schDate), 'yyyy-MM-dd', this.restrictAppointmentRecordDeleteDate, 'day')) {
          this.$sn.assembly.modal({
            caption: Messages.APPOINT040,
            success: (modal) => {
              if (modal.confirm) {
                const digital = {
                  url: this.$sn.format.caption(Swagger.deleteAppointmentRecord, [encodeURIComponent(item.appointId)]),
                  method: 'DELETE',
                  header: true
                };
                this.$sn.assembly.loading(true);
                this.$sn.utils.ordinaryRequest(digital).then(result => {
                  this.$sn.assembly.loading(false);
                  if (result) {
                    if (result.code === 0) {
                      this.$sn.assembly.toast({
                        caption: this.$sn.format.caption(Messages.C016, ['删除']),
                        mode: 'success',
                        success: () => {
                          this.appointment_mixin_navigateUrl('/appointment/record', '', {}, 'replace');
                        }
                      });
                    }
                    else {
                      this.$sn.assembly.modal({
                        caption: result.msg,
                        isCancel: false
                      });
                    }
                  }
                  else {
                    this.$sn.assembly.modal({
                      caption: Messages.C001,
                      isCancel: false
                    });
                  }
                });
              }
            }
          });
        }
      }
      else if (url.substring(0, 4) === 'http' || url.substring(0, 7) === '/static' || url.substring(0, 2) === '//') {
        window.open(url);
      }
      else {
        this.$router[type]({
          path: url,
          query: params || {}
        });
      }
    }
  }
};
